<template>
    <div class="h-screen flex w-full">
        <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
            <img v-if="has_error" src="@/assets/images/pages/404_2.png" alt="graphic-404" class="mx-auto mb-0 max-w-full">
            <h4 class="sm:mx-0 mx-0 mb-12 text-3xl">
                {{ has_error ? 'Invalid invoice url. Please contact admin!' : 'Please wait...' }}
            </h4>
        </div>
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const InvoiceRepository = RepositoryFactory.get('invoice')

export default {
    name: 'InvoiceRedirectPage',
    data() {
        return {
            has_error: false
        }
    },
    async mounted() {
        try {
            const { data } = (await InvoiceRepository.redirectToInvoice(this.$route.params.code)).data
            setTimeout(async () => {
                window.location.href = data.link
            }, 500)
        } catch (error) {
            this.has_error = true
        }
    },

}
</script>
<style scoped>
    
</style>